/**
 * Referral
 */
export const Referral = (function () {

  var init =  function () {
    
    $('.self-refer').on('click', function(e) {
      e.preventDefault();
      let urlPath = window.location.href.split('/');
      let serviceId = urlPath[urlPath.length - 1];
      let organisationId = $('#service-name').attr('data-id');
      let selfReferralData = $('.form-self-referral').serializeArray();

      referralsCalls(serviceId, organisationId, selfReferralData);

    });
  }
  
  return {
    init: init
  }

}());
/**
 * Ajax call to get the service data
 * @param {string} url - endpoint from where to get the service data
 * @returns Deferred object response
 */
let getService = function (url) {
  return $.ajax({
    type: 'GET',
    dataType: 'json',
    headers: {
        'isAPI': true
    },
    url: url
  });
}

/**
 * Ajax call to post the referral data
 * @param {string} url - endpoint from where to get the service data
 * @param {object} data - data to send in the request body
 * @returns Deferred object response
 */
 let postData = function (url, data) {
  var csrf = Util.getCSRF();

  return $.ajax({
    type: 'POST',
    headers: {
      'x-csrf-token': csrf
    },
    url: url,
    data: data
  });
}

/**
 * Formats the data to be sent to the dataset ds_referrals
 * @param {array} selfReferal 
 * @param {object} serviceData 
 * @returns object - data to be sent to the pds to write to ds_referrals dataset
 */
let formatSelfReferral = function (selfReferal, serviceData) {
  let data = {};
  let am = [];
  let pm = [];

  $(selfReferal).each((i, el) => {
  let name = el.name;
    if (el.value !== '') {
      if (el.name.includes('AM')) {
        am.push(formatAvailabilityString(el.name));
      } else if (name.includes('PM')) {
        pm.push(formatAvailabilityString(el.name));
      } else {
        if (!checkValueIsValid(el.value)) {
          data['error'] = true;
          return false;
        }
        data[el.name] = el.value
      }
    }
  });
  // check if the object data contains a key named 'error'
  // this will mean the value is not valid and we cannot continue formatting the data
  if (data.hasOwnProperty('error')) {
    return false;
  }
  
  data['availability'] = {
    AM: am,
    PM: pm
  };
  
  return {
    'service_id': serviceData.service_id,
    'service_name': serviceData.service_name,
    'service_description': serviceData.service_description,
    'service_url': serviceData.service_url,
    'service_email': serviceData.service_email,
    'contact_name': '',
    'contact_title': '',
    'contact_number': serviceData.service_contact_number,
    'referrer_name': '',
    'status': 'Referred',
    'referree_background': 'background' in data ? data.background : '',
    'referree_requirements': 'requirements' in data ? data.requirements : '',
    'referree_availability': 'availability' in data ? JSON.stringify(data.availability) : '',
    'type': 'Self Referred',
    'updated_timestamp': Date.now()
  }
}

/**
 * Receives a string containing the name chosed for availability and returns just the day (string)
 * @param {string} field 
 * @returns string - day chose for availability
 */
let formatAvailabilityString = function (field) {
  let availableDay = field.split('-');
  return availableDay[availableDay.length-1];
}

/**
 * Gets a string and checks its value against a regex expression
 * @param {string} value - string value to validate
 * @returns boolean - true/false whether the value matches the expression
 */
let checkValueIsValid = function (value) {
  let regex = /^[a-z0-9.,;"'\s]+$/i;
  return regex.test(value);
}
/**
 * nested ajax requests done in a particular order:
 * First request the service data
 * Second post referral data to the user PDS
 * Finally post referral data to be added in the inapp dataset table
 * @param {string} serviceId id of the service
 * @param {string} organisationId id of the organisation offering the service
 * @param {array} data data of the self referral
 */
let referralsCalls = function (serviceId, organisationId, data) {
  let service = '';
  let pdsReferralData = '';
  let messageError = 'Sorry, an error occurred. Please try again.';

  let promise = getService(`/service-directory/service/${serviceId}/${organisationId}`);
  promise.done(function(response) {
    // when the ajax call has return a successful response format the data and send it to the PDS
    service = response.service;
    pdsReferralData = formatSelfReferral(data, service);

    if (!pdsReferralData) {
      return Util.toggleAlert('#myds-alert-self-referral-modal', 'Only alphanumeric characters allowed and ,."', 'alert-warning', 8000);
    }

    let pdsPromise = PDS.pds.post('ds_referrals', pdsReferralData);
    pdsPromise.done(function (result) {
      // when the ajax call has return a successful response send the data to add it to the inapp table
      let inappReferral = {
        pds_id: result.last_insert_id,
        status: 'Referred',
        type: 'Self Referred',
        service_id: service.service_id,
        id: '0',
        organisation_id: organisationId
      }

      postData('/inapp-referrals', inappReferral).done(function(response) {
        $('#referral').modal('hide');
        $('#myds-referral-button').parent('div').remove();
        Util.toggleAlert('#myds-alert-service-referral-card', "Success: Self referral made.", 'alert-success', -1);

        }).fail(function (err) {
          Util.toggleAlert('#myds-alert-self-referral-modal', messageError, 'alert-warning', 8000);
        });

    }).fail(function (err) {
      Util.toggleAlert('#myds-alert-self-referral-modal', messageError, 'alert-warning', 8000);
    });
  });

  promise.fail(function(error) {
      Util.toggleAlert('#myds-alert-self-referral-modal', 'User attempting to access unavailable service.', 'alert-warning', 8000);
  });
}